import React from 'react';
import { motion } from 'framer-motion';

const WAVE_PATH =
  'M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z';

const Waves = ({ color }) => (
  <div className="pointer-events-none absolute bottom-0 left-0 h-64 w-full overflow-hidden opacity-60">
    <motion.svg
      className="absolute bottom-0 h-full w-[200%]"
      viewBox="0 0 1200 120"
      preserveAspectRatio="none"
      animate={{ x: ['0%', '-50%'] }}
      transition={{ repeat: Infinity, ease: 'linear', duration: 20 }}
    >
      <path d={WAVE_PATH} fill={color} opacity="0.22" transform="translate(0,50)" />
      <path d={WAVE_PATH} fill={color} opacity="0.16" transform="translate(600,50)" />
    </motion.svg>

    <motion.svg
      className="absolute bottom-0 h-full w-[200%]"
      viewBox="0 0 1200 120"
      preserveAspectRatio="none"
      animate={{ x: ['-50%', '0%'] }}
      transition={{ repeat: Infinity, ease: 'linear', duration: 15 }}
    >
      <path d={WAVE_PATH} fill={color} opacity="0.13" transform="translate(0,40)" />
      <path d={WAVE_PATH} fill={color} opacity="0.1" transform="translate(600,40)" />
    </motion.svg>
  </div>
);

export default Waves;